// extracted by mini-css-extract-plugin
module.exports = {"finishes":"foilSquare_finishes__iSdMA","foil":"foilSquare_foil__RqYCW","gap":"foilSquare_gap__IdKVY"};